import React from "react";

type Props = {};

const BannerSignup: React.FC<Props> = (): JSX.Element => {
  return (
    <>
      <div className="flex flex-col my-28">
        <div className="flex flex-row justify-center items-center">
          <span
            className="font-nunito text-lg"
            style={{
              fontStyle: "normal",
              fontWeight: 400,
              color: "#43425D",
            }}
          >
            Thank you for getting in touch!
          </span>
        </div>
        <div className="flex flex-row justify-center items-center">
          <span
            className="font-nunito text-lg"
            style={{
              fontStyle: "normal",
              fontWeight: 400,
              color: "#43425D",
            }}
          >
            Our team will contact you as soon as possible
          </span>
        </div>
      </div>
    </>
  );
};

export default BannerSignup;
